import { useSecureGraphqlQuery } from '@psyomics/ui-common';

import { GetReportDataDocument, GetReportDataQuery, GetReportDataQueryVariables } from '../generated/report';

type ErrorType = 'ReportNotFound' | 'ReferralCancelled' | 'InviteExpired' | 'ReferralPending';

const useReportQuery = ({
  referrer,
  referralId,
  referralSessionId,
}: {
  referrer?: string;
  referralId: string;
  referralSessionId?: string;
}) => {
  const [{ data, errorMessage, fetching }] = useSecureGraphqlQuery<
    GetReportDataQuery,
    GetReportDataQueryVariables,
    ErrorType
  >(
    {
      query: GetReportDataDocument,
      variables: {
        input: {
          referrer,
          referralId,
          referralSessionId,
        },
      },
    },
    ['ReportNotFound', 'ReferralCancelled', 'InviteExpired', 'ReferralPending']
  );
  return { data, errorMessage, fetching };
};

export type { ErrorType };
export { useReportQuery };
